import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lista-noticias',
  templateUrl: './lista-noticias.component.html',
  styleUrls: ['./lista-noticias.component.scss'],
})
export class ListaNoticiasComponent implements OnInit {
  public news = [];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.getNews();
  }
  truncateText(texto) {
    if (texto.length >= 77) {
      return texto.substr(0, 77) + '...';
    }
    return texto.substr(0, 77);
  }
  getNews() {
    this.news = [
      {
        categoria_noticia: 'Metaversos',
        link_imagen_noticia:
          'https://diariobitcoin.b-cdn.net/wp-content/uploads/2022/06/metaverso-unsplash.jpg',
        link_noticia:
          'https://www.diariobitcoin.coauth/metaverso/el-metaverso-podria-valer-nada-mas-y-nada-menos-que-usd-5-billones-para-2030/',
        titulo_noticia:
          'El metaverso podría valer nada más y nada menos que USD $5 billones para 2030',
      },
      {
        categoria_noticia: 'Metaversos',
        link_imagen_noticia:
          'https://s03.s3c.es/imag/_v0/1200x655/d/b/a/metaverso.jpg',
        link_noticia:
          'https://www.eleconomista.es/tecnologia/noticias/11815807/06/22/Francia-sera-el-primer-pais-en-tener-una-academia-especifica-para-el-met',
        titulo_noticia:
          'Francia será el primer país en tener una academia específica para el metaverso',
      },
      {
        categoria_noticia: 'Metaversos',
        link_imagen_noticia:
          'http://static.pulzo.com/images/20220724155444/cropped-f1874fbb-dfc0-417e-abf5-97d565f4a512-3.jpg',
        link_noticia:
          'https://www.larepublica.co/analisis/stefan-krautwald-3166366/metaverso-oportunidad-para-colombia-3260090',
        titulo_noticia: 'Metaverso, ¿oportunidad para Colombia?',
      },
      {
        categoria_noticia: 'Metaversos',
        link_imagen_noticia: 'https://cdn.forbes.co/2022/04/Saju.jpg',
        link_noticia:
          'https://forbes.co/2022/04/13/editors-picks/asi-es-el-metaverso-made-in-colombia/',
        titulo_noticia: 'Así es el metaverso ‘made in Colombia’',
      },
    ];
  }
  goToMisEventos() {
    this.router.navigate(['auth/events']);
  }
  goToNoticias() {
    this.router.navigate(['auth/news']);
  }
  goToPlanes() {
    this.router.navigate(['auth/plans']);
  }
}
